module.exports = __webpack_public_path__ + "img/CF_2W.2.711c6a61.jpg";